import { Component, OnInit } from '@angular/core';
import { Users, Projects, Logs, Activities, Updates } from 'api/collections';
import { User, Project, Log, LogType, LogCategories, LogMessageType, Update, Activity } from 'api/models';
import { AlertController, ViewController, NavParams, ToastController, PopoverController, LoadingController, ActionSheetController} from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import * as permissions from '../../services/permissions';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { PictureService } from '../../services/picture';
import { AugmentedActivity, ActivityService } from '../../services/activityData';
import { LogMenuComponent } from '../../components/log-menu/log-menu';
import { LogView } from '../logs/log-view';
import { ActivityDetailsPage } from '../activity-details/activity-details';
import { SharedService } from '../../services/sharedService';
import { App } from "ionic-angular";
import { ISDEV, APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { AuthenticationService } from '../../services/congito';

@Component({
  selector: 'new-log',
  templateUrl: 'new-log.html',
  styleUrls: ['/pages/new-log/new-log.scss']
})
export class NewLogComponent implements OnInit {
  public isDev = ISDEV;
  public disabled = false;
  logs: Array < Log & { updateId ? : string, update ? : Update } > ;
  selectedProject: Project | void;
  activityId: string;
  update: Update | void; //holds Project info for activity list
  projectId: string;
  p6ActivityId: string;
  activity: AugmentedActivity | void;
  logType: LogType;
  newLogTitle: string;
  newLogSelection: string;
  newLogCategory: string;
  logTypeLabel: string;
  initialPhoto: string | void;
  rawInitialPhoto: string | void;
  initialTextMessage: string | void;
  project: Project | void;
  updateId: string;


  logCategoryOptions = [
    { value: LogCategories.CHANGES, label: 'Changes' },
    { value: LogCategories.DELAYS, label: 'Delays/Issues' },
    { value: LogCategories.INSPECTIONS, label: 'Inspections' },
    { value: LogCategories.SAFETY, label: 'Site Safety' },
    { value: LogCategories.NOTES, label: 'Subcontractor Notes' },
    { value: LogCategories.TODO, label: 'To Do List' },
    { value: LogCategories.WEATHER, label: 'Weather' },
  ];

  constructor(
    private _app: App,
    public authenticationService: AuthenticationService,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private popoverCtrl: PopoverController,
    private pictureService: PictureService,
    private loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private sharedService: SharedService,
    public httpService: HttpService,
    private activityService: ActivityService,
    public projectService: ProjectService
  ) {
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }


  ngOnInit() {
    if(this.isDev == true) { console.log('new logs page') }
    const projectIdReactive = this.navParams.get('projectIdReactive');
    const projectId = projectIdReactive && projectIdReactive.get();
    this.project = this.projectService.getProject(projectId);
    this.p6ActivityId = <string> this.navParams.get('p6ActivityId');
    const activityId = < string > this.navParams.get('activityId');
    console.log('activity id ng init:', activityId)
    const activity = Activities.findOne(activityId);
    this.logType = activityId ? LogType.ACTIVITY : LogType.GENERAL;
    this.projectId = < string > this.navParams.get('projectId');
    this.updateId = <string> this.navParams.get('updateId');
    if(this.isDev == true) { console.log('new logs page: activity ID ' + activityId + ' Log Type ' + this.logType + ' Project ID ' + this.projectId + ' ' ) }
    

    /*
    MeteorObservable.subscribe('currentUpdateForProject', this.projectId).subscribe(() => {
      if(!this.updateId){
        this.update = Updates.find({
          projectId: this.projectId,
          archived: {$ne:true}
        }, {
          limit: 1,
          sort: { createdAt: -1 },
        }).fetch()[0];
      } else {
        this.update = Updates.find({
          _id: this.updateId,
        }, {
          limit: 1,
          sort: { createdAt: -1 },
        }).fetch()[0];
      }
    });
    */

    this.httpService.MeteorSubscribe('currentUpdateForProject', this.projectId)
    .then(()=>this.httpService.privateLoopAction(true));
    if(!this.updateId){
      this.update = Updates.find({
        projectId: this.projectId,
        archived: {$ne:true}
      }, {
        limit: 1,
        sort: { createdAt: -1 },
      }).fetch()[0];
    } else {
      this.update = Updates.find({
        _id: this.updateId,
      }, {
        limit: 1,
        sort: { createdAt: -1 },
      }).fetch()[0];
    }

    if (this.logType === LogType.ACTIVITY) {
      this.logTypeLabel = 'Activity Log';
    } else if (this.logType === LogType.GENERAL) {
      this.logTypeLabel = 'General Project Log';
    } else {
      this.logTypeLabel = 'Unknown';
    }

    // TODO should subscribe to guarantee the activity data is available
    MeteorObservable.autorun().subscribe(() => {
      /*
      MeteorObservable.call("getActivity",
        activityId
      ).subscribe({
        next: (res: any) => {
          if(this.isDev == true) { console.log("finding activity ", activityId, res) }
          this.activity = res ? getAugmentedActivity(res) : null;
        }
      })
      */
      if(activityId){
        this.httpService.MeteorCall("getActivity", activityId)
        .then((res: any) => {
          if(this.isDev == true) { console.log("finding activity ", activityId, res) }
          this.activity = res ? this.activityService.getAugmentedActivity(res) : null;
        })
        .catch((e: Error) => {
          console.log('meteor call error:', e);
        });

      }

      this.project = this.projectService.getProject(this.projectId);

     if(this.isDev == true) {  console.log('log menu page: activity ID ' + activityId + ' Log Type ' + this.logType + ' Project ID ' + this.projectId) }
    });
  }

  eventHandler(keyCode){
    if(keyCode==13){
      let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }
  showAttachments(): void {
    this.pictureService.getPicture(this.actionSheetCtrl)
      .then((blob: File) => {
      if(this.isDev == true) {   console.log("starting", new Date().getTime()) }
        let loading = this.loadingCtrl.create({
          content: 'Uploading image...',
          duration: 10*1000,
        });

        loading.present();
        this.pictureService.upload(blob).then(async (picture) => {
         if(this.isDev == true) {  console.log("finish", new Date().getTime()) }
         this.rawInitialPhoto=picture.url;
         this.initialPhoto = await this.authenticationService.imageConverter(picture.url);
          loading.dismiss();
        }).catch((e) => {
          loading.dismiss();
        });
      });
  }

  async addLog() {
    if (this.logType === LogType.ACTIVITY && !this.activity) {
      return this.showError(new Error('Bad input: missing activity'));
    }

    if (!this.initialTextMessage ||!this.newLogCategory || !this.newLogTitle) {
      return this.showError(new Error('Bad input: missing Title, Category or Log Entry text'));;
    }

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
    this.disabled = true;
    /*
    MeteorObservable.call('addLog', {
      logType: this.logType,
      title: this.newLogTitle,
      p6ActivityId: this.activity ? this.activity.p6ActivityId : undefined, // optional, only present for LogType.ACTIVITY
      projectId: this.projectId,
      category: this.newLogCategory,
    }, this.initialPhoto, this.initialTextMessage).subscribe({
      next: async (newLogId: string) => {
        this.sharedService.logUpdate.emit(this.activity);
        await loader.dismiss()
        this.viewCtrl || this.viewCtrl.dismiss().then(() => {
        this.showToast('Log successfully added.');

         });
      },

      error: async (e: Error) => {
        loader.dismiss()
       if(this.isDev == true) {  console.log("error adding log", e) }
          this.showError(e);
      }
    });
    */

    return this.httpService.MeteorCall('addLog',
      {
        logType: this.logType,
        title: this.newLogTitle,
        p6ActivityId: this.activity ? this.activity.p6ActivityId : undefined, // optional, only present for LogType.ACTIVITY
        projectId: this.projectId,
        category: this.newLogCategory,
      },
      this.rawInitialPhoto,
      this.initialTextMessage
    ).then(async (newLogId: any) => {
      this.httpService.refreshSubscriptions();
      if(this.activity){
        this.sharedService.logUpdate.emit(this.activity);
      }


      console.log("newLogIdnewLogIdnewLogId", newLogId)
      try{
        await loader.dismiss();
      } catch(err){}


      this.viewCtrl.dismiss().then(() => {
        this.showToast('Log successfully added.');
      }).catch(err=>console.log(err));
    })
    .catch((e: Error) => {
      console.log('meteor call error:', e);
    })
  }

   presentLoading() {
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 500,
      enableBackdropDismiss: true,
    });
    loader.present();
  }

  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message,
      duration: 2500,
      position: 'top',
      dismissOnPageChange: true,
    });

    toast.present();
    return toast;
  }

  showError(e: Error): void {
   if(this.isDev == true) {  console.error(e) }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/new-log/new-log.ts